import React from "react";
import PropTypes from "prop-types";
import i18next from "i18next";
import { getContrastColor } from "utils/utils";

/** Detecta colores muy claros (casi blancos) para forzar contraste de la función. */
const isVeryLightColor = (hex) => {
	if (!hex || typeof hex !== "string") return false;
	const cleanHex = hex.replace("#", "");
	let r;
	let g;
	let b;
	if (cleanHex.length === 3) {
		r = parseInt(cleanHex[0] + cleanHex[0], 16);
		g = parseInt(cleanHex[1] + cleanHex[1], 16);
		b = parseInt(cleanHex[2] + cleanHex[2], 16);
	} else if (cleanHex.length === 6) {
		r = parseInt(cleanHex.substring(0, 2), 16);
		g = parseInt(cleanHex.substring(2, 4), 16);
		b = parseInt(cleanHex.substring(4, 6), 16);
	} else {
		return false;
	}
	if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return false;
	const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
	return luminance > 0.9;
};

/**
 * Tarjeta de persona para la vista "Turnos" de planificación.
 * Reutiliza el diseño de ShiftCard usando el color de fondo del turno.
 * Muestra: nombre completo, badge de función y badge IA (a la derecha).
 */
const PlanPersonCard = ({ name, functionObj, shift, badge }) => {
	const backgroundColor = shift?.background_color || "";
	const borderColor = shift?.border_color || backgroundColor;
	const textColor = getContrastColor(backgroundColor);

	const shiftIsLight =
		!backgroundColor || isVeryLightColor(backgroundColor);

	const functionStyle = functionObj?.background_color
		? {
				backgroundColor: functionObj.background_color,
				borderColor: functionObj.background_color,
				color: getContrastColor(functionObj.background_color),
		  }
		: {
				backgroundColor: shiftIsLight ? "#000000" : backgroundColor,
				borderColor: shiftIsLight
					? "#000000"
					: borderColor || backgroundColor,
				color: shiftIsLight ? "#FFFFFF" : getContrastColor(backgroundColor),
		  };

	return (
		<article
			className="plan-person-card"
			style={{
				backgroundColor: backgroundColor || undefined,
				borderColor: borderColor || undefined,
				color: textColor,
			}}
		>
			<header className="plan-person-card__header">
				<span className="plan-person-card__name" title={name}>
					{name}
				</span>
				{badge ? (
					<div className="plan-person-card__badge">{badge}</div>
				) : null}
			</header>

			<div className="plan-person-card__body">
				<span
					className="plan-person-card__function"
					title={functionObj ? functionObj.name : i18next.t("plan.noFunction")}
					style={functionStyle}
				>
					{functionObj ? functionObj.name : i18next.t("plan.noFunction")}
				</span>
			</div>
		</article>
	);
};

PlanPersonCard.propTypes = {
	name: PropTypes.string.isRequired,
	functionObj: PropTypes.object,
	shift: PropTypes.object.isRequired,
	badge: PropTypes.node,
};

PlanPersonCard.defaultProps = {
	functionObj: null,
	badge: null,
};

export default PlanPersonCard;
